import type { CSS } from '@volue/wave-react';
import { Box, Button, Flex } from '@volue/wave-react';
import type { ButtonProps } from '@volue/wave-react/dist/ts/components/Button';
import React from 'react';

export type ButtonGroupButton = {
  props: ButtonProps;
  children: React.ReactNode;
};

export type ButtonGroupProps = {
  buttons: ButtonGroupButton[];
  css?: CSS;
};

function overrideButtonStyling(isFirst: boolean, isLast: boolean) {
  if (isFirst && isLast) {
    return {
      borderRadius: '0.5rem'
    };
  }
  if (isFirst) {
    return {
      borderRadius: '0.5rem 0.5rem 0 0',
      borderBottom: '0'
    };
  }
  if (isLast) {
    return {
      borderRadius: '0 0 0.5rem 0.5rem',
      borderTop: '0'
    };
  }
  return {
    borderRadius: '0',
    borderTop: '0',
    borderBottom: '0'
  };
}

function Divider() {
  return (
    <Flex
      cross="center"
      flow="column"
      css={{
        background: '$colorWhite',
        borderWidth: '0 1px',
        borderStyle: 'solid',
        borderColor: '$colorGray15',
        width: '2.75rem'
      }}
    >
      <Box
        css={{
          width: '2rem',
          height: '0',
          borderBottom: '1px solid $colorGray10'
        }}
      />
    </Flex>
  );
}

export function ButtonGroup({ buttons, css }: ButtonGroupProps) {
  return (
    <Flex gap="none" flow="column" cross="center" css={css}>
      {buttons.map((buttonDefinition, index) => {
        const isFirst = index === 0;
        const isLast = index === buttons.length - 1;
        return (
          <React.Fragment key={buttonDefinition.props.key}>
            <Button
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...buttonDefinition.props}
              css={{ margin: 0, ...overrideButtonStyling(isFirst, isLast) }}
            >
              {buttonDefinition.children}
            </Button>
            {!isLast ? <Divider /> : null}
          </React.Fragment>
        );
      })}
    </Flex>
  );
}
